module.exports = __webpack_public_path__ + "static/ux-journey-map-8b46b10b786e770f6cb4a9d0687f66e3.svg";